import { type CompletedSessions, Periodicity } from "@modules/completedSessions/completedSessionsType"
import { type PublicProfileApiGateway } from "@modules/profile/publicProfile/gateway/publicProfileApi.gateway"
import { GenderCategory, type PublicProfileDto } from "@modules/profile/publicProfile/gateway/publicProfileDto"
import { type UserDto } from "@modules/profile/userProfile/userDto"

const _HEAD_COACH_USER_FAKE_DATA: UserDto = {
  id: "head_coach_default",
  username: "Head Coach default username",
  firstname: "Head Coach default firstname",
  lastname: "Head Coach default lastname",
  avatar: null,
}
const _HEAD_COACH_PROFILE_FAKE_DATA: PublicProfileDto = {
  ..._HEAD_COACH_USER_FAKE_DATA,
  userId: _HEAD_COACH_USER_FAKE_DATA.id,
  avatar: null,
  favoritesPersonalRecords: [],
  badges: [],
  followedPrograms: [],
  ownedPrograms: [],
  sharedCoachPrograms: [],
  biography: null,
  birthdate: null,
  crossfitStartDate: null,
  genderCategory: null,
  job: null,
  nationality: null,
  height: null,
  weight: null,
  followedProgramBundle: [],
}

const _BOX_OWNER_USER_FAKE_DATA: UserDto = {
  id: "box_owner_default",
  username: "Box Owner default username",
  firstname: "Box Owner default firstname",
  lastname: "Box Owner default lastname",
  avatar: null,
}
const _BOX_OWNER_PROFILE_FAKE_DATA: PublicProfileDto = {
  ..._BOX_OWNER_USER_FAKE_DATA,
  userId: _BOX_OWNER_USER_FAKE_DATA.id,
  avatar: null,
  favoritesPersonalRecords: [],
  badges: [],
  followedPrograms: [],
  ownedPrograms: [],
  sharedCoachPrograms: [],
  biography: null,
  birthdate: null,
  crossfitStartDate: null,
  genderCategory: null,
  job: null,
  nationality: null,
  height: null,
  weight: null,
  followedProgramBundle: [],
}

const _COACH_USER_FAKE_DATA: UserDto = {
  id: "coach_default",
  username: "Coach default username",
  firstname: "Coach default firstname",
  lastname: "Coach default lastname",
  avatar: null,
}
const _COACH_PROFILE_FAKE_DATA: PublicProfileDto = {
  ..._COACH_USER_FAKE_DATA,
  userId: _COACH_USER_FAKE_DATA.id,
  avatar: null,
  favoritesPersonalRecords: [],
  badges: [],
  followedPrograms: [],
  ownedPrograms: [],
  sharedCoachPrograms: [],
  biography: null,
  birthdate: null,
  crossfitStartDate: null,
  genderCategory: null,
  job: null,
  nationality: null,
  height: null,
  weight: null,
  followedProgramBundle: [],
}

const _ATHLETE_USER_FAKE_DATA: UserDto = {
  id: "athlete_default",
  username: "Athlete default username",
  firstname: "Athlete default firstname",
  lastname: "Athlete default lastname",
  avatar: null,
}
const _ATHLETE_PROFILE_FAKE_DATA: PublicProfileDto = {
  ..._ATHLETE_USER_FAKE_DATA,
  userId: _ATHLETE_USER_FAKE_DATA.id,
  avatar: null,
  favoritesPersonalRecords: [],
  badges: [],
  followedPrograms: [],
  ownedPrograms: [],
  sharedCoachPrograms: [],
  biography: null,
  birthdate: null,
  crossfitStartDate: null,
  genderCategory: null,
  job: null,
  nationality: null,
  height: null,
  weight: null,
  followedProgramBundle: [],
}

const _ATHLETE_COMPLETE_USER_FAKE_DATA: UserDto = {
  id: "athlete_rich_profile",
  firstname: "Athlete rich profile firstname",
  lastname: "Athlete rich profile lastname",
  username: "athlete_rich_profile",
  avatar: null,
}
const _ATHLETE_COMPLETE_PROFILE_FAKE_DATA: PublicProfileDto = {
  ..._ATHLETE_COMPLETE_USER_FAKE_DATA,
  userId: _ATHLETE_COMPLETE_USER_FAKE_DATA.id,
  avatar: {
    url: "path",
    hash: "blurHash",
  },
  nationality: "French",
  job: "Developer",
  biography: "I am a developer",
  birthdate: "01/01/1990",
  weight: 70,
  height: 180,
  crossfitStartDate: "01/01/2020",
  genderCategory: GenderCategory.FEMALE,
  favoritesPersonalRecords: [],
  badges: [],
  followedPrograms: [],
  ownedPrograms: [],
  sharedCoachPrograms: [],
  followedProgramBundle: [],
}

export const USER_TEST_DATA = {
  DEFAULT: _ATHLETE_USER_FAKE_DATA,
  HEAD_COACH: _HEAD_COACH_USER_FAKE_DATA,
  COACH: _COACH_USER_FAKE_DATA,
  ATHLETE: _ATHLETE_USER_FAKE_DATA,
  ATHLETE_COMPLETE_PROFILE: _ATHLETE_COMPLETE_USER_FAKE_DATA,
  OWNER: _BOX_OWNER_USER_FAKE_DATA,
}
export const PROFILE_TEST_DATA = {
  HEAD_COACH: _HEAD_COACH_PROFILE_FAKE_DATA,
  COACH: _COACH_PROFILE_FAKE_DATA,
  ATHLETE: _ATHLETE_PROFILE_FAKE_DATA,
  ATHLETE_COMPLETE_PROFILE: _ATHLETE_COMPLETE_PROFILE_FAKE_DATA,
  OWNER: _BOX_OWNER_PROFILE_FAKE_DATA,
}

export class FakePublicProfileApi implements PublicProfileApiGateway {
  profiles: Record<string, PublicProfileDto> = {}

  givenProfile(profile: PublicProfileDto) {
    this.profiles[profile.userId] = profile
  }

  getProfile(profileId: string): Promise<PublicProfileDto> {
    const profile = this.profiles[profileId]

    if (!profile) {
      throw new Error("Profile not found")
    }

    return Promise.resolve(profile)
  }

  getCompletedSessions(_: string, __: Periodicity, ___: number): Promise<CompletedSessions[]> {
    return Promise.resolve([])
  }
}
